module.exports = __webpack_public_path__ + "static/img/sggs_img_5.9a1b0a5f.png";